export default "__VITE_ASSET__CDYgwEuf__"